import {getApiConfig} from './../../../utilities';
import * as actions from '../../../actions'
import * as PJActions from './../../ProjectScope/ProjectScopeActions';
import * as selectors from './NewFeatureSelector';
import FeatureCreatorActions from './../FeatureCreatorNewActions';
import customEvent from "../../../utilities/customEvent";
import {updateFeatureAfterEditPopup} from "../../FeaturesSetup/featuresActions";

const {post} = getApiConfig('Dashboard_Feature');


export const NewFeatureActionTypes = {
  SET_EDIT: 'new-feature/set_edit',
  SHOW_OVERLAY_NEW: 'new-feature/show-overlay-new',
  SET_NEW_FEATURE_DATA: 'new-feature/set-new-feature-data',
  SET_NEW_FEATURE_DATA_RELATED: 'new-feature/set-new-feature-data-related',
  RESET_FEATURE_DATA: 'new-feature/reset-feature-data',
  SET_BUNDLE_Q_TIES: 'new-feature/set-feature-bundle-quantities',
};

export const showNewFeatureOverlay = (overlayVisible, group = null, featureDefinitionId = null) => ({
  type: NewFeatureActionTypes.SHOW_OVERLAY_NEW,
  payload: {
    overlayVisible,
    group,
    featureDefinitionId
  }
});

export const resetFeatureData = () => ({
  type: NewFeatureActionTypes.RESET_FEATURE_DATA,
  payload: {}
});

export const setBundleQuantities = (bundledFeaturesQuantities) => ({
  type: NewFeatureActionTypes.SET_BUNDLE_Q_TIES,
  payload: {bundledFeaturesQuantities}
});

export function saveFeature(data) {
  //console.log("saveFeature", data);
  return (dispatch, getState) => {
    const state = getState();
    return dispatch(actions.loadingDialog_show(true, 'Saving Product...', 'Saving Product Data...'))
      .then(() => post(data, 'SaveFeature'))
      .then(() => dispatch(actions.loadingDialog_show(false)))
      .then(() => {
        if (window.location.href.includes("features-setup")) {
          return dispatch(updateFeatureAfterEditPopup(data, state));
        }
        return dispatch(FeatureCreatorActions.loadFeatures(state.featuresCreatorNew.activeFeaturesGroupName, data.catId))
      })
      .then(() => document.dispatchEvent(customEvent('save-new-feature')));
  }
}

export function getFeatureData(featureDefinitionId, catId) {
  return (dispatch, getState) => {
    dispatch(actions.loadingDialog_show(true, 'Loading Product...', 'Loading Product Data...'));
    return getApiConfig('projectScope').get('/features-groups-edit/' + featureDefinitionId + '/' + catId)
      .then(data => {
        dispatch(actions.loadingDialog_show(false, 'Loading Product...', 'Loading Product Data...'));
        console.log("getFeatureData", data);
        if(!data.__error__) {
          const displayLogicFeatures = data.fabricatorFeature.displayLogicFeatures.slice(0);
          delete data.fabricatorFeature.displayLogicFeatures;
          dispatch({
            type: NewFeatureActionTypes.SET_NEW_FEATURE_DATA,
            payload: {data}
          });
          return displayLogicFeatures
        }
      });
  }
}

export function getFeatureDataRelated() {
  return (dispatch) => {
    return getApiConfig('projectScope').get('/features-groups-edit-related')
      .then(lightFeaturesGroups => {
        if(!lightFeaturesGroups.__error__) {
          dispatch({
            type: NewFeatureActionTypes.SET_NEW_FEATURE_DATA_RELATED,
            payload: {lightFeaturesGroups}
          });
        }
      });
  }
}
